import * as S from "./DrvieStatusItem.style";

export interface StatusItemProps {
  title?: string;
  value?: string;
  color: string;
}

export const DriveStatusItem = ({ title, value, color }: StatusItemProps) => {
  return (
    <S.DriveStatusItem>
      <S.DriveStatusLabel color={color}>
        {title} <div />
      </S.DriveStatusLabel>
      {value}
    </S.DriveStatusItem>
  );
};
